/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FieldMappingEntry
 */
export interface FieldMappingEntry {
    /**
     * 
     * @type {string}
     * @memberof FieldMappingEntry
     */
    stotlesField: string;
    /**
     * 
     * @type {string}
     * @memberof FieldMappingEntry
     */
    crmField: string;
}

/**
 * Check if a given object implements the FieldMappingEntry interface.
 */
export function instanceOfFieldMappingEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stotlesField" in value;
    isInstance = isInstance && "crmField" in value;

    return isInstance;
}

export function FieldMappingEntryFromJSON(json: any): FieldMappingEntry {
    return FieldMappingEntryFromJSONTyped(json, false);
}

export function FieldMappingEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldMappingEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stotlesField': json['stotlesField'],
        'crmField': json['crmField'],
    };
}

export function FieldMappingEntryToJSON(value?: FieldMappingEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stotlesField': value.stotlesField,
        'crmField': value.crmField,
    };
}

